
import Experience from './Experience/Experience.js'

window.IronSight = function GrealiVision(myObject){


const experience = new Experience(myObject)



}
IronSight(IronSight("https://viewer-dev.zipcpq.com/models/ConwayMachine/object.js"))